module.exports = __webpack_public_path__ + "static/media/denuncia_orange.9d985ed5.svg";